import type { EnhancedProductVariantId } from '#api/enhancements/enhancedTmsApiTypes'

export const removalVariants = ['Z', 'ZZ', '-']

/**
 * Decides if a Variant Id is a removal, without or unselected:
 * - `Z` or `ZZ` are `without` selections
 * - `-` is an "unselection", meaning no explicit selection or a selection is not applicable
 */
export const isVariantRemoval = (id: EnhancedProductVariantId) => removalVariants.includes(id)
export const isVariantOption = (id: EnhancedProductVariantId) => !isVariantRemoval(id)
